import script from "./TheKv.vue?vue&type=script&setup=true&lang=js"
export * from "./TheKv.vue?vue&type=script&setup=true&lang=js"

import "./TheKv.vue?vue&type=style&index=0&id=71688e0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71688e0e"]])

export default __exports__